module.exports = __webpack_public_path__ + "assets/media/eggs_sakana.baef52f6.mp3";